<template>
  <v-card
    :title="strings[idioma].dietas_salvas"
    class="elevation-3"
    flat
    wrap
  >
    <v-sheet :class="(type === 'DIETAS_ATIVAS') ? 'pa-3 green' : 'pa-3 primary'">
      <v-layout
        row
        wrap>
        <v-flex xs10>
          <v-text-field
            v-model="searchDieta"
            :title="'' + strings[idioma].dietas_salvas +' >> ' + strings[idioma].pesquisar"
            :label="(type === 'DIETAS_ATIVAS') ? strings[idioma].dietas_ativas : strings[idioma].dietas_salvas"
            dark
            flat
            solo-inverted
            hide-details
            clearable
            append-icon="mdi-magnify"
            clear-icon="mdi-close"
          />
        </v-flex>
        <v-flex xs2>
          <v-btn
            :title="'' + strings[idioma].dietas_salvas +' >> ' + strings[idioma].criar_novo"
            :label="strings[idioma].dietas_salvas"
            href="/formulacao-dieta?new"
            dark
            flat
            icon
            solo-inverted
            hide-details
            clearable
            append-icon="mdi-magnify"
            clear-icon="mdi-close"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-sheet>
    <v-tabs v-model="tab">
      <v-tab>{{ strings[idioma].crescimento_terminacao }}</v-tab>
      <v-tab>{{ strings[idioma].vaca }}</v-tab>
      <v-tab>{{ strings[idioma].bezerro }}</v-tab>
    </v-tabs>
    <div style="padding: 0; margin: 0; min-height: 200px; max-height: 200px; width: 100%; overflow:auto; background: #fff">

      <v-card
        style="padding: 0; margin: 0; width: 100%"
        tile
      >
        <v-list
          two-line
          dense
          flat
          rounded>
          <div color="primary">
            <template
              v-for="(dieta, index) in dietasFilter">
              <v-list-tile
                :key="index"
                :title="strings[idioma].dietas_salvas + ' >> ' + dieta.nome"
                :style="(dieta.compartilhamento && dieta.compartilhamento.lido === 0) ? {'background': '#f5f5f5', 'color': 'red'} : {}"
                flat
                color="primary"
                @click="(remove) ? removeDieta(dieta) : (compartilha) ? compartilhar(dieta) :openDieta(dieta)">
                <v-list-tile-avatar>
                  <v-icon
                    :class="'text-uppercase' + ((dieta.dieta_ativa) ? ((moment().diff(dieta.dieta_ativa.data_fim_real || dieta.dieta_ativa.data_fim_esperado, 'days') < 0) ? ' primary--text' : ' green--text') : '')"
                    v-text="'mdi-folder'"
                  />
                  <v-icon
                    v-if="dieta.dieta_ativa"
                    :class="'text-uppercase' + ((dieta.dieta_ativa) ? ((moment().diff(dieta.dieta_ativa.data_fim_real || dieta.dieta_ativa.data_fim_esperado, 'days') < 0) ? ' primary--text' : ' green--text') : '')"
                    v-text="'mdi-star'"
                  />
                </v-list-tile-avatar>
                <v-list-tile-content style="min-width: 70%">
                  <v-list-tile-title
                    :class="'text-uppercase' + ((dieta.dieta_ativa) ? ((moment().diff(dieta.dieta_ativa.data_fim_real || dieta.dieta_ativa.data_fim_esperado, 'days') < 0) ? ' primary--text' : ' green--text') : '')"
                  >
                    {{ '#' + dieta.id }} -
                    <template v-if="dieta.nome !== ''">
                      {{ dieta.nome.replace('Em Predição', strings[idioma].em_predicao) }}
                    </template>
                    <template v-else-if="tabCompartilhamento !== 0">
                      {{ strings[idioma].dieta_x_compartilhada.format('#' + dieta.id) }}
                    </template>
                    <template v-else>
                      {{ strings[idioma].dieta_ativa.format('#' + dieta.id) }}
                    </template>

                  </v-list-tile-title>
                  <v-list-tile-sub-title>{{ moment(dieta.time).format(strings[idioma].formato_datas_com_hora) }}  <small style="font-size: 9px;">( {{ (dieta.animal.peso_corporal_final + dieta.animal.peso_corporal_inicial) / 2 }} Kg. - {{ dieta.animal.ganho_medio_diario }} Kg.- {{ strings[idioma][dieta.animal.tipo] }} )</small>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title v-if="dieta.dieta_ativa">
                    <small
                      :class="'text-uppercase' + ((dieta.dieta_ativa) ? ((moment().diff(dieta.dieta_ativa.data_fim_real || dieta.dieta_ativa.data_fim_esperado, 'days') < 0) ? ' primary--text' : ' green--text') : '')"
                      style="font-size: 9px;">
                      <b>[{{ strings[idioma][dieta.dieta_ativa.tipo_confinamento] ? strings[idioma][dieta.dieta_ativa.tipo_confinamento] : dieta.dieta_ativa.tipo_confinamento }}]</b>
                      {{ strings[idioma].data_inicial_sigla }}: <strong style="font-size: 9px;">{{ moment(dieta.dieta_ativa.data_inicio).format(strings[idioma].formato_datas_sem_hora) }}</strong>
                      <template v-if="!dieta.dieta_ativa.data_fim_real"> {{ strings[idioma].data_final_sigla }}({{ strings[idioma].esperado }}): <strong style="font-size: 9px;">{{ moment(dieta.dieta_ativa.data_fim_esperado).format(strings[idioma].formato_datas_sem_hora) }}</strong></template>
                      <template v-else> {{ strings[idioma].finalizado_em }}: <strong style="font-size: 9px;">{{ moment(dieta.dieta_ativa.data_fim_real).format(strings[idioma].formato_datas_sem_hora) }}</strong></template>

                    </small>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    <template v-if="dieta.id_dono">
                      <small>{{ strings[idioma].recebida_de }}:&nbsp;</small>
                      <small style="color: black; font-weight: bold;">{{ dieta.nome_dono }}</small>
                    </template>
                    <template v-if="dieta.compComQuem">
                      <small>{{ strings[idioma].compartilhado_com }}:&nbsp;</small>
                      <span
                        v-for="u in dieta.compComQuem"
                        :key="u.id">
                        <small style="color: blue">({{ u.NOME }}) </small>
                      </span>
                    </template>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    v-if="tabCompartilhamento !== 2 && type === null"
                    icon
                    flat
                    color="primary"
                    small
                    @click="dietaCorrente = dieta; compartilha = true;"> <v-icon small>mdi-share</v-icon> </v-btn>
                  <v-btn
                    v-if="type === null"
                    :title="'' + strings[idioma].dietas_salvas + ' >> ' + dieta.nome + ' >> DELETE'"
                    icon
                    flat
                    color="error"
                    small
                    @click="remove = true"> <v-icon small>mdi-close</v-icon> </v-btn>
                  <v-btn
                    v-if="tabCompartilhamento !== 2 && type === 'DIETAS_ATIVAS' && dieta.dieta_ativa.data_fim_real === null && moment().diff(dieta.dieta_ativa.data_fim_esperado, 'days') > 0"
                    :title="strings[idioma].dieta_fora_do_prazo"
                    icon
                    color="error"
                    flat
                    small><v-icon>mdi-alert</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </div>
        </v-list>

      </v-card>
    </div>
    <v-tabs
      v-if="dietasCompartilhadasComigo && dietasCompartilhadasComOutros && type === null"
      v-model="tabCompartilhamento">
      <v-tab>{{ strings[idioma].minhas_dietas }}</v-tab>
      <v-tab>{{ strings[idioma].compartilhados_por_mim }}</v-tab>
      <v-tab :style="temDietasCompartilhadasPendentes ? 'color: red' : ''">{{ strings[idioma].compartilhados_para_mim }} <span v-if="temDietasCompartilhadasPendentes">*</span></v-tab>
    </v-tabs>
    <CompartilharDialog
      ref="compartilharDialog"
      :dieta_salva="dietaCorrente"
      :dieta="dietaCorrente">
      <div />
    </CompartilharDialog>
  </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getData, updateData, createMD5 } from '@/utils/utils'
import CompartilharDialog from './CompartilharDialog'
import moment from 'moment'
import {
  replaceSpecialChars
} from '@/utils/vuex'
import { DIETAS_ATIVAS_ILIMITADAS, FUNCAO_PREMIUM } from '../../utils/types'
export default {
  components: {
    CompartilharDialog
  },
  props: {
    type: {
      type: String || Object,
      default: () => null
    }
  },
  data () {
    return {
      linkURL: null,
      loadingAlimentos: false,
      searchDieta: null,
      tab: 0,
      tabCompartilhamento: 0,
      tabEnum: ['crescimento_terminacao', 'vaca', 'bezerro'],
      dietas_: null,
      dietaCorrente: null
    }
  },
  computed: {
    ...mapState('app', ['acesso_premium', 'strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas', 'dietasCompartilhadasComigo', 'dietasCompartilhadasComOutros', 'dietasAtivas', 'notificacoes']),
    Dietas () {
      let dietasAtivas = Object.values(Object.assign({}, this.dietasAtivas))
      if (dietasAtivas !== null && dietasAtivas.map && this.type === 'DIETAS_ATIVAS' && !this.getAcessoModulo({ user: this.user, modulo: DIETAS_ATIVAS_ILIMITADAS })) {
        let dietasAtivasNF = dietasAtivas.filter(d => d.dieta_ativa && d.dieta_ativa.data_fim_real === null).slice(0, 5)
        let dietasAtivasF = dietasAtivas.filter(d => d.dieta_ativa && d.dieta_ativa.data_fim_real !== null)
        dietasAtivas = dietasAtivasNF ? dietasAtivasNF.concat(dietasAtivasF) : dietasAtivasF
      }
      if (this.type === 'DIETAS_ATIVAS') return dietasAtivas === null ? [] : dietasAtivas
      switch (this.tabCompartilhamento) {
        case 0:
          return this.dietas
        case 2:
          return this.dietasCompartilhadasComigo
        case 1:
          return this.dietasCompartilhadasComOutros
      }
    },
    temDietasCompartilhadasPendentes () {
      const notificacoes = this.notificacoes
      return notificacoes && notificacoes['dietasCompartilhadas'] && notificacoes['dietasCompartilhadas'].length > 0 && notificacoes['dietasCompartilhadas'].filter(d => d.tipo_dieta === 0).length > 0
    },
    dietasSalvas () {
      let dietas = this.Dietas
      return (dietas !== null) ? dietas.filter(p => p.user_id === this.user.id) : []
    },
    possuiDietas () {
      let dietas = this.Dietas
      return dietas && dietas.length >= 0 && this.dietasSalvas.length > 0
    },
    dietasFilter () {
      let cliente = localStorage.getItem('cliente')
      let idCliente = null
      if (cliente && cliente !== null) {
        cliente = JSON.parse(cliente)
        idCliente = cliente.id
      }
      let dietas = this.Dietas
      if (dietas === null || !dietas.map) return dietas
      dietas = dietas.map(d => {
        let res = { ...d }
        res['nomeCompletoPesquisa'] = '#' + res['id'] + ' - ' + res['id'] + ' - ' + (res['nome'] ? res['nome'] : res['name'])
        return res
      })

      if (idCliente !== null) {
        dietas = dietas.filter(d => d.animal && d.animal.tipo === this.tabEnum[this.tab] && d.id_cliente === idCliente)
        if (this.searchDieta === null || this.searchDieta.trim() === '') return dietas.filter(u => u.animal && u.animal.tipo && (u.animal.tipo !== '' && u.animal.tipo !== null) && u.id_cliente === idCliente)
        return dietas.filter(u => u.animal && new RegExp(replaceSpecialChars(this.searchDieta.toLowerCase()), 'i').test(u.nomeCompletoPesquisa) && u.animal && u.animal.tipo && (u.animal.tipo !== '' && u.animal.tipo !== null) && u.id_cliente === idCliente)
      }
      dietas = dietas.filter(d => d.animal && d.animal.tipo === this.tabEnum[this.tab])
      if (this.searchDieta === null || this.searchDieta.trim() === '') return dietas.filter(u => u.animal && u.animal.tipo && (u.animal.tipo !== '' && u.animal.tipo !== null))
      return dietas.filter(u => u.animal && new RegExp(replaceSpecialChars(this.searchDieta.toLowerCase()), 'i').test(u.nomeCompletoPesquisa) && u.animal && u.animal.tipo && (u.animal.tipo !== '' && u.animal.tipo !== null))
    }
  },
  created () {
    this.getData().then(() => {
      if (this.type === 'DIETAS_ATIVAS') this.$store.dispatch('getDietasAtivas')
      this.$store.dispatch('getDietasCompartilhadas')
      let tipos = []
      for (let d of this.dietas) {
        if (!d.animal || d.animal.tipo === undefined) continue
        if (!tipos[d.animal.tipo]) tipos[d.animal.tipo] = 0
        tipos[d.animal.tipo]++
      }
      if (tipos['crescimento_terminacao']) this.tab = 0
      else if (tipos['vaca']) this.tab = 1
      else if (tipos['bezerro']) this.tab = 2
      this.tabCompartilhamento = 0
    })
  },
  methods: {
    ...mapActions(['setDietaLida', 'ocultarDietaRecebida']),
    async _ocultarDietaRecebida (dieta) {
      let res = await this.ocultarDietaRecebida(dieta)
      return res
    },
    compartilhar (dieta) {
      delete this.compartilha
      dieta.assinatura = createMD5(String(dieta.id))
      this.$refs.compartilharDialog.open()
      let url = window.location.origin + '/formulacao-dieta?did=' + dieta.id + '&assinatura=' + dieta.assinatura
      this.$copyText(url).then(function (e) {
        
      }, function (e) {
        
      })
    },
    moment (...args) {
      return moment(...args)
    },
    getData () {
      this.$store.state.app.tabHome = -1
      return getData(this.$store.state, this.axios)
    },
    updateData () {
      return updateData(this.$store.state, this.axios)
    },
    async openDieta (dieta) {
      this.$store.commit('loadDieta', dieta)
      setTimeout(async () => {
        let url = '/formulacao-dieta?did=' + dieta.id + '&assinatura=' + createMD5(String(dieta.id))
        if (dieta.compartilhamento) {
          url += '&compartilhamento=' + btoa(JSON.stringify(dieta.compartilhamento))
          dieta.id_compartilhamento = dieta.compartilhamento.id_compartilhamento
          dieta.id_pessoa = this.user.id
          await this.setDietaLida(dieta)
        }
        window.location.href = url
      }, 300)
    },
    removeDieta (dieta) {
      delete this.remove

      return this.$confirm(this.$store.state, this.strings[this.idioma].msg_remove_confirm).then((r) => {
        if (r === 'sim') {
          if (this.tabCompartilhamento === 2 && dieta.comp_user) {
            return this._ocultarDietaRecebida(dieta).then(() => {
              this.getData()
              this.updateData()
              this.$store.dispatch('getDietasCompartilhadas')
            }).catch((r) => {
              console.log({ r })
              alert('Não foi possivel remover/ocultar dieta!')
            })
          }
          if (this.tabCompartilhamento > 0) {
            return this.axios.post('compartilhar/remove', { id: dieta.compartilhamento.id }).then(res => {
              this.getData()
              this.updateData()
              this.$store.dispatch('getDietasCompartilhadas')
            })
          }
          this.$store.dispatch('removeDieta', dieta).catch(_ => console.log('Problema ao remover dieta!!!')).then(_ => {
            this.getData()
            this.updateData()
          })
        }
      })
    }
  }
}
</script>
